<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">学员充值情况</span>
            </template>
            <template #left>
                <router-link to="/my">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>

        <van-tabs v-model="tabActive" @click="onLoad(true)">
            <van-tab title="本月" name="this_month"/>
            <van-tab title="上月" name="last_month"/>
        </van-tabs>


        <br>
        <table border="1" cellspacing="0" cellpadding="0" style="width: 800px">

            <tr>
                <th>序号</th>
                <th>上级id</th>
                <th>id</th>
                <th>姓名</th>
                <th>微信号</th>
                <th>金额</th>
                <th>数量</th>
                <th>笔单数</th>
                <th>提成</th>
                <th>提成金额</th>
                <th>下级提成</th>
                <th>最终金额</th>
            </tr>

            <tr v-for="(organ,index) in organs" :key="organ.id">
                <td>{{index+1}}</td>
                <td>{{0==organ.pid?'':organ.pid}}</td>
                <td>{{organ.id}}</td>
                <td>{{organ.creator_nickname}}</td>
                <td>{{organ.we_chat_number}}</td>
                <td>{{organ.amount}}</td>
                <td>{{organ.quantity}}</td>
                <td>{{organ.quantity}}</td>
                <td>{{organ.commission_percentage}}</td>
                <td>{{organ.commission_amount}}</td>
                <td>{{organ.pid_commission_amount}}</td>
                <td>{{organ.total_amount}}</td>
            </tr>
        </table>


    </div>
</template>

<script>
    export default {
        data() {
            return {

                tabActive: "this_month",
                organs: [],


            };
        },
        created() {
            this.onLoad()
        },
        methods: {
            onLoad() {
                this.organs = [];
                this.$http.get("/wechat/organ/statistics", {
                    params: {
                        special: this.tabActive,
                    }
                }).then(res => {
                    this.loading = false;
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.error = true
                        this.error_text = res.data.msg
                        return
                    }
                    this.organs = res.data.data
                });
            }
        }
    }
</script>
